import React, { useState } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";

// Orange color palette - matching ComplianceShield
const ORANGE_COLORS = {
  primary: '#FF5B00',
  dark: '#e85a28',
  darker: '#d14d1f',
  light: '#ff8c61',
  lighter: '#ffb399',
  subtle: '#fff5f0',
  muted: '#ffe8dd',
};

const toRgba = (hex, alpha) => {
  const value = hex.replace("#", "");
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const iconChip = (color) => ({
  width: 32,
  height: 32,
  borderRadius: 8,
  border: `0.5px solid ${toRgba(color, 0.30)}`,
  background: toRgba(color, 0.10),
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const iconGlyph = (color) => ({
  color,
  fontSize: 18,
  lineHeight: 1,
});

const MetricTile = ({ label, value, icon, color, borderColor }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card 
      className="card-animate" 
      style={{ 
        background: "var(--vz-secondary-bg, #fff)",
        border: "1px solid var(--vz-border-color)",
        borderRadius: 10,
        transition: 'all 0.3s ease',
        transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
        boxShadow: isHovered ? '0 8px 18px rgba(0,0,0,0.08)' : '0 1px 4px rgba(0,0,0,0.06)',
        cursor: 'pointer'
      }}
      onMouseEnter={() => setIsHovered(true)} 
      onMouseLeave={() => setIsHovered(false)}
    >
      <CardBody>
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <p className="text-uppercase fw-medium text-muted mb-0">
              {label}
            </p>
          </div>
          <div className="flex-shrink-0">
            <div style={iconChip(color)}>
              <div style={iconGlyph(color)}>
                {icon}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-end justify-content-between mt-4">
          <div>
            <h4 
              className="fs-22 fw-semibold ff-secondary mb-4" 
              style={{ color: color }}
            >
              {value !== null && value !== undefined ? value.toLocaleString() : '0'}
            </h4>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

const Tiles = ({
  totalRules,
  activeDetections,
  highSeverityRules,
}) => {
  const tileData = [
    {
      label: "Total Rules",
      value: totalRules,
      icon: <i className="ri-file-list-3-line" />,
      color: ORANGE_COLORS.primary,
      borderColor: 'var(--vz-border-color)',
    },
    {
      label: "Active Detections",
      value: activeDetections,
      icon: <i className="ri-alert-line" />,
      color: ORANGE_COLORS.dark,
      borderColor: 'var(--vz-border-color)',
    },
    {
      label: "High Severity Rules",
      value: highSeverityRules,
      icon: <i className="ri-error-warning-line" />,
      color: ORANGE_COLORS.darker,
      borderColor: 'var(--vz-border-color)',
    }
  ];

  return (
    <Row className="g-3 mb-4">
      {tileData.map((tile, idx) => (
        <Col lg={4} md={4} sm={12} xs={12} key={idx}>
          <MetricTile {...tile} />
        </Col>
      ))}
    </Row>
  );
};

export default Tiles;
